import { z } from "zod";
import { emailSchema } from "../common/email.js";
import { ContactSubject } from "./contact-subject.js";

export const contactFormSchema = z.object({
	name: z.string().trim().min(2, { message: "Name must be at least 2 characters long" }).max(120),
	email: emailSchema,
	subject: z.enum(ContactSubject, { message: "Please select a subject" }),
	message: z.string().trim().min(10, { message: "Message must be at least 10 characters long" }).max(4000),
	company: z.string().trim().max(120).optional(),
});

export type ContactFormPayload = z.infer<typeof contactFormSchema>;
